import React from 'react';
import pt from 'prop-types';
import _ from 'underscore';
import moment from 'moment';
import Ev from '../../../lib/event';
import Loader from '../../../common/components/notifications/Loader';
import ConfirmModal from '../components/ConfirmModal';
import Snack from '../../../common/components/SnackMessage';
import path from 'ramda/src/path';
import { Link } from 'react-router-dom'
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent';
import schema from '../../../routes/permissions/schema';

_.mixin({
    capitalize: function (string) {
        return string.charAt(0).toUpperCase() +
            string.substring(1).toLowerCase();
    }
});

// show a list of ott channels
function OttList (props) {

    return <div className="ott-list container-fluid">
        {props.channels.resolving.length ?
            <Loader message="loading" /> :
            body(props)
        }
    </div>;
}

var events = OttList.manifest = [
    'openDeleteModal',
    'closeDeleteModal',
    'delete',
    'shiftMessage'
].reduce(function (acc, type) {
    acc[type] = Ev(type);
    return acc;
}, {});


function body (props) {
    if (props.channels.errors.length) {
        return HttpError(props.channels.errors[0]);
    }

    var channels = _(props.channels.data).toArray();

    /*
    var channels = [
        {
            "ottChannelID": "4",
            "channelName": "TVW",
            "language": "en",
            "beginDate": "2015-01-01",
            "defaultImage": "cad8b987be313f145065b4f01ccbd9887c90619b",
            "cueForUpdate": true,
            "jobs": [
                {
                    "jobID": "1",
                    "clientID": "1000000000",
                    "submittedOn": "2017-05-26 10:48:00",
                    "acceptedOn": null,
                    "resolvedOn": null,
                    "notes": "OTT Job was Submitted Successfully on 2017-05-26 10:48:00",
                    "ottTargetType": "roku",
                    "ottJobStatus": "pending",
                    "ottChannelID": "1"
                }
            ],
            "ottTargets": [
                "roku"
            ],
            "categories": [
                {
                    "categoryID": "76",
                    "defaultImage": "25f1e5c2f51e4d52b7e962ef7e0e7e9161f90dad"
                }
            ],
            "persistentStreams": [
                {
                    "persistentStreamID": "6",
                    "encoderID": "TVWAIR",
                    "title": "TVW Cable Channel",
                    "defaultImage": "36920ef551cb4a832fad8cc56f1f6a371fcb6cd8"
                }
            ]
        }
    ];
*/

    return [
        <ConfirmModal key={0}
            show={props.channels.deleteModalOpen}
            onHide={_.compose(
                props.push,
                events.closeDeleteModal,
                _.constant(null)
            )}
            onConfirm={function() {
                props.push(events.delete({ottChannelID: props.channels.pendingDeleteID}))
                props.push(Ev('closeDeleteModal', null))
                props.push(Ev('resolve', {op: 'delete'}))
                delete props.channels.data[props.channels.pendingDeleteID]
            }}
            title={props.channels.deleteModalOpen ?
                ('Delete channel "' + _(channels).findWhere({
                    ottChannelID: props.channels.pendingDeleteID
                }).channelName + '"') :
                ''
            }
            message="This cannot be undone and you will lose all of this channel's data"
        />,

        <Snack key={'snack'}
            timeout={4000}
            message={path(
                ['channels', 'crudMessages', 0, 'message'],
                props
            ) || ''}
            isOpen={!!props.channels.crudMessages.length}
            onClose={_.compose(
                props.push,
                events.shiftMessage
            )}
            type="success"
        />,

        <div className="row callout text-right" key={1}>
            <RestrictedComponent permissionCheck={schema.MANAGE_OTT.CREATE}>
                <Link to="/manage/ott/edit"
                    className="btn btn-primary"
                >
                    <i className="fa fa-plus"/> Create new channel
                </Link>
            </RestrictedComponent>
        </div>,

        (!channels.length ?
            <div className="row" key={2}>
                {NoData()}
            </div> :

            <ul className="list-unstyled" key={2}>
                {channels.map(function (channel, i) {
                    return <li key={i} className="row" style={{
                        backgroundColor: 'white',
                        height: '8em'
                    }}>

                        <div className="list-item-image col-sm-2" style={{
                            height: '100%'
                        }}>
                            <img src={getChannelImage(channel, props)}
                                className="img-responsive"
                                style={{
                                    padding: '0.4em',
                                    maxHeight: '100%'
                                }}
                            />
                        </div>

                        <div className="col-sm-10" style={{
                            height: '100%',
                            paddingTop: '1em'
                        }}>
                            <h4 className="col-sm-8">
                                {channel.channelName}
                            </h4>

                            <div className="col-sm-4 text-right">
                                <div className="btn-group">
                                    <RestrictedComponent permissionCheck={schema.MANAGE_OTT.UPDATE}>
                                        <Link
                                            to={'/manage/ott/edit?id=' +
                                                channel.ottChannelID}
                                            className="btn btn-default"
                                        >
                                            <i className="fa fa-pencil"/> Edit
                                        </Link>
                                    </RestrictedComponent>
                                    <RestrictedComponent permissionCheck={schema.MANAGE_OTT.DELETE}>
                                        <button className="btn btn-danger"
                                            onClick={_.compose(
                                                props.push,
                                                events.openDeleteModal,
                                                function (ev) {
                                                    ev.preventDefault();
                                                    return channel.ottChannelID;
                                                }
                                            )}>
                                            <i className="fa fa-trash-can"/> Delete
                                        </button>
                                    </RestrictedComponent>
                                </div>
                            </div>

                            <div className="col-sm-12 pull-right">
                                <small>
                                    {Targets(channel.ottTargets)} |
                                    Created {moment(channel.beginDate)
                                        .format('MMM D, YYYY')}
                                </small>
                            </div>

                            <JobMessages channel={channel} />
                        </div>


                    </li>;
                })}
            </ul>
        )

    ];
}

function JobMessages (props) {
    var alert = null;
    for (var i = 0; i < props.channel.ottTargets.length; i++) {
        var target = props.channel.ottTargets[i];
        var job = _(props.channel.jobs).findWhere({
            ottTargetType: target
        });

        if (!job) {
            alert = <div className="alert alert-warning" role="alert" key={i}>
                <span
                    className="glyphicon glyphicon-exclamation-sign"
                    aria-hidden="true"
                > </span>
                <RestrictedComponent permissionCheck={schema.MANAGE_OTT.UPDATE}>
                    <Link to={'/manage/ott/roku?id=' +
                        props.channel.ottChannelID}
                    >
                        {' ' + _.capitalize(target) + ' needs to be setup'}
                    </Link>
                </RestrictedComponent>
            </div>;
            break;
        }

        if (job.ottJobStatus == 'pending') {
            alert = <div className="alert alert-info" role="alert" key={i}>
                <span
                    className="glyphicon glyphicon-exclamation-sign"
                    aria-hidden="true"
                > </span>
                {' ' + _.capitalize(target) + ' setup is pending'}
            </div>;
            break;
        }
    }

    return <div className="col-sm-6">
        <small>
            {alert}
        </small>
    </div>;
}


function HttpError (error) {
    return <div className="alert alert-danger" role="alert">
        <span className="glyphicon glyphicon-exclamation-sign"
            aria-hidden="true"> </span>
        <span className="sr-only">Error:</span>
        {' ' + error.message}
    </div>;
}

function NoData () {
    return <div className="alert alert-info" role="alert">
        You don't have any OTT channels yet
    </div>;
}

function getChannelImage (channel, props) {
    if (props.assets.resolving.length) return null;
    if (!Object.keys(props.assets.data).length) return '';
    // this asset could have been deleted
    const channelAsset = props.assets.data[channel.defaultImage]
    if (channelAsset) return channelAsset.fileUrl
    return ''
}

function Targets (arr) {
    return arr.reduce(function (acc, t) {
        return acc + t.charAt(0).toUpperCase() + t.substring(1);
    }, '');
}


OttList.propTypes = {
    channels: pt.object.isRequired
};

export default OttList;
